import intersect from './intersect'

const legendsToRender = (layersToggled, authLayers, serviceLayers) => {
  const legends = intersect(layersToggled, serviceLayers)
  // console.log(legends)

  // console.log(layersToggled)
  // console.log(authLayers)
  // console.log(serviceLayers)
  return legends
}

export default legendsToRender



// WEBPACK FOOTER //
// ./src/utility/legendsToRender.js